<template>
  <div
    class="cart-item-height cursor-pointer d-flex align-center"
    @click.stop="toEditOrProductDetail"
  >
    <div
      v-if="warn"
      @click.stop="warn = !warn"
      class="d-flex flex-column justify-space-around"
    >
      <AlcoholWarning
        v-if="product.is_alcohol"
        :xs="$vuetify.breakpoint.xsOnly"
      />
      <TobaccoWarning
        v-if="product.is_tobacco"
        :xs="$vuetify.breakpoint.xsOnly"
      />
      <div class="d-flex justify-center">
        <a>
          <v-icon color="primary">mdi-chevron-down</v-icon>
        </a>
      </div>
    </div>
    <div v-else class="full-width">
      <v-row align="center" no-gutters>
        <v-col
          class="align-center d-flex justify-center min-height-120px overflow-hidden position-relative"
          cols="4"
        >
          <FavoriteIcon :upc="upc" class="favorite-button-position" mobile />
          <CornerRibbon
            v-if="
              !product.is_redemption &&
              !product.redemption_points_offer_id &&
              ((product.pricebook_info.promotions &&
                product.pricebook_info.promotions.length) ||
                product.new_product)
            "
            :newItem="
              !(
                product.pricebook_info.promotions &&
                product.pricebook_info.promotions.length
              )
            "
          />
          <img
            v-if="product.image"
            :alt="product.name"
            :src="product.image"
            class="product-image-size-xs"
          />
          <NoImageAvailable
            v-else
            :departmentName="
              getProductDepartmentName(
                product.parent_categories,
                product.categories,
              )
            "
            :size="'xs'"
          />
          <v-btn
            v-if="product.modifier_groups"
            @click.stop="edit(cartProduct)"
            class="add-extra-button-position"
            color="primary"
            text
            x-small
          >
            <span class="text-capitalize">add/edit extras</span>
          </v-btn>
        </v-col>

        <v-col cols="4" class="align-center d-flex">
          <div class="d-flex flex-column justify-center ml-2">
            <PromotionsPriceDisplay
              class="e2e-cartitem-price"
              :byweight="product.byweight"
              :items="items"
              :product="product"
              :qty="displayQuantity"
            />
            <div class="e2e-cartitem-name">
              {{ product.name ? product.name : "Product" }}
            </div>
            <UnitSizeDisplay
              :baseSize="product.base_size"
              :size="product.size"
              :small="$vuetify.breakpoint.xsOnly"
              :uom="product.uom"
              class="e2e-cartitem-size"
            />
            <table>
              <tbody>
                <tr
                  class="color-suva-grey font-size-sm-res"
                  v-for="(modifier, i) in product.modifiers"
                  :key="`${modifier.upc}${i}`"
                >
                  <td class="text-no-wrap">{{ modifier.name }}</td>
                  <td>
                    <span v-if="modifier.cents" class="text-center text-no-wrap"
                      >{{ "\xa0" }}(+{{ formatCurrency(modifier.cents) }})</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>

        <v-col
          class="align-center d-flex flex-column justify-center position-relative"
          cols="4"
        >
          <a
            :class="product.qty > 1 ? 'visible' : 'hidden'"
            class="e2e-remove-all font-size-sm-res font-weight-semibold"
            @click.stop="remove"
            >Remove All</a
          >
          <slot name="cartQuantityButton" :cartProduct="cartProduct"></slot>
          <slot
            name="quantityButton"
            :displayQuantity="displayQuantity"
            :less="less"
            :more="more"
          ></slot>
          <TermsSingle
            class="pt-3"
            v-if="currentCartItem"
            :byweight="product.byweight"
            :promotions="product.pricebook_info.promotions"
            small
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <div
            class="font-size-sm-res text-center"
            :class="
              product.is_tobacco || product.is_alcohol ? 'visible' : 'hidden'
            "
            @click.stop="warn = !warn"
          >
            California Residents:
            <a>Click here for Proposition 65 WARNING</a>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  formatCurrency,
  getProductDepartmentName,
  getProductDetailViewFromProductState,
} from "@/util.js";
import AlcoholWarning from "@/components/Product/AlcoholWarning.vue";
import FavoriteIcon from "@/components/Product/FavoriteIcon.vue";
import NoImageAvailable from "@/components/Product/NoImageAvailable.vue";
import CornerRibbon from "@/components/Product/Promotions/CornerRibbon.vue";
import PromotionsPriceDisplay from "@/components/Product/Promotions/PriceDisplay.vue";
import TermsSingle from "@/components/Product/Promotions/Terms/Single.vue";
import TobaccoWarning from "@/components/Product/TobaccoWarning.vue";
import UnitSizeDisplay from "@/components/Product/UnitSizeDisplay.vue";

export default {
  name: "CartItem",
  components: {
    AlcoholWarning,
    FavoriteIcon,
    NoImageAvailable,
    CornerRibbon,
    PromotionsPriceDisplay,
    TermsSingle,
    TobaccoWarning,
    UnitSizeDisplay,
  },
  computed: {
    ...mapGetters({
      getProductItemsAndQuantityInCart: "cart/getProductItemsAndQuantityInCart",
    }),
    cartProduct() {
      const itemsAndQuantityFromCart = this.getProductItemsAndQuantityInCart(
        this.product,
      );
      return { ...this.product, ...itemsAndQuantityFromCart };
    },
    displayQuantity() {
      return parseFloat(
        this.modifiedQty !== undefined && this.modifiedQty !== null
          ? this.modifiedQty
          : this.product.qty,
      );
    },
    notCategoryPage() {
      return !this.$route.params.categoryId;
    },
  },
  data: () => ({
    warn: false,
  }),
  methods: {
    closeAddFromCartDialogAndOpenModifiersDialog() {
      this.$store.dispatch("product/openDialog", "modifiers");
      this.close();
    },
    edit(product) {
      this.$store.dispatch("product/editModifier", product);
      this.$vuetify.breakpoint.xsOnly
        ? this.$route.name === "product"
          ? this.$router.push({
              name: "product",
              params: { upc: this.product.upc_encoded },
              query: { view: "modifiers" },
            })
          : this.$router.push({
              name: "product",
              params: {
                from: "addFromCart",
                upc: product.upc_encoded,
                view: "modifiers",
              },
            })
        : this.closeAddFromCartDialogAndOpenModifiersDialog();
    },
    formatCurrency,
    getProductDepartmentName,
    less() {
      const q = this.modifiedQty !== null ? this.modifiedQty : this.product.qty;
      const qp = parseFloat(q);
      const qty = this.product.byweight ? qp - 0.5 : qp - 1;
      if (qty < 0) {
        return;
      }
      this.modifyCartItems({ ...this.product, qty });
    },
    more() {
      const q = this.modifiedQty !== null ? this.modifiedQty : this.product.qty;
      const qp = parseFloat(q);
      const qty = this.product.byweight ? qp + 0.5 : qp + 1;
      this.modifyCartItems({ ...this.product, qty });
    },
    remove() {
      const { item_id: itemId } = this.product;

      this.currentCartItem &&
        this.cartProduct.cartItems &&
        this.$store.commit("product/REMOVE_CART_ITEM", itemId);
      this.$store.commit("cart/REMOVE", itemId);
      this.$store.dispatch("cart/remove", itemId);
    },
    toProductDetail() {
      this.$store.dispatch(
        "product/setCurrentProductDetails",
        this.cartProduct,
      );
      const view = getProductDetailViewFromProductState(this.cartProduct);
      let routeName =
        this.product.is_redemption || this.product.redemption_points_offer_id
          ? "rewardProduct"
          : "product";
      this.$vuetify.breakpoint.xsOnly
        ? this.$router.push({
            name: routeName,
            params: { upc: this.cartProduct.upc_encoded, view },
            query: routeName === "rewardProduct" ? this.$route.query : {},
          }) // this is only ok on xs when in cart
        : this.$store.dispatch("product/openDialog", view);
    },
    toEditOrProductDetail() {
      this.product.modifier_groups
        ? this.edit(this.cartProduct)
        : this.toProductDetail();
    },
  },
  props: {
    close: Function,
    currentCartItem: Boolean,
    items: Object,
    modifiedQty: Number,
    modifyCartItems: Function,
    product: Object,
    upc: String,
  },
};
</script>

<style scoped>
.add-extra-button-position {
  position: absolute;
  bottom: 0;
}

.cart-item-height {
  min-height: 162px;
}

.favorite-button-position {
  position: absolute;
  top: 0;
  left: 0;
}

.min-height-120px {
  min-height: 120px;
}

.prop-65-warning-position {
  position: absolute;
  bottom: 0;
  left: 20px;
}
</style>
